import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {AuthenticationService} from '../../../guards/authentication.service';

@Component({
  selector: 'app-header-back-end',
  templateUrl: './header-back-end.component.html',
  styleUrls: ['./header-back-end.component.css']
})
export class HeaderBackEndComponent implements OnInit {

  constructor(
    private router: Router, private authenticationService: AuthenticationService
  ) { }

  ngOnInit(): void {
  }

  logout(): void {
    this.authenticationService.logout();
    this.router.navigate(['dashboard']);
  }

}
